import { Component } from '@angular/core';

@Component({
  selector: 'app-department-icon',
  imports: [],
  templateUrl: './department-icon.html',
  styleUrl: './department-icon.scss',
})
export class DepartmentIcon {}
